// extracted by mini-css-extract-plugin
module.exports = {"menu":"IconsButtons_menu__3ex7Q","active":"IconsButtons_active__LpLD5"};